import { useCallback } from 'react';
import { initial, skipped, usePulseClient, useParseOptions, useSyncResource } from './shared';

// Overload for param-using resource (keep first for intellisense)
// The homomorphic mapped type seems pointless, but is required for full expected property
// checking behavior. I've tagged the relevant test in useResource-types-test.tsx
// with [homomorphic type test]
// Overload for param-less resource
// Implementation
export function useResource(resource, options) {
  const {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient,
    instanceKey
  } = useParseOptions(resource, options);
  const client = usePulseClient();
  const resourceForClient = resource;
  const getSnapshot = useCallback(() => {
    var _client$getState;
    return skip || !client ? skipped : (_client$getState = client.getState({
      resource: resourceForClient,
      params,
      instanceKey
    })) !== null && _client$getState !== void 0 ? _client$getState : initial;
  },
  // instanceKey is a proxy for params and resource changing
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [skip, instanceKey, client]);
  return useSyncResource(getSnapshot, instanceKey, resourceForClient, params, skip, pollInterval, client, httpClient, pollGroup);
}